import { createFileRoute, redirect } from "@tanstack/react-router";
import { Roles } from "@hometoq/backend/enums";
import { getCurrentUserSafe } from "@/domain/auth/auth.query";

export const Route = createFileRoute("/dashboard/")({
  loader: async () => {
    const user = await getCurrentUserSafe();
    if (!user) {
      throw redirect({ to: "/connexion" });
    }

    if (user.role === Roles.CHEF) {
      throw redirect({ to: "/dashboard/chef" });
    } else if (user.role === Roles.CUSTOMER) {
      throw redirect({ to: "/dashboard/client" });
    } else if (user.role === Roles.ADMIN) {
      throw redirect({ to: "/dashboard/admin" });
    } else {
      throw redirect({ to: "/connexion" });
    }
  },
  component: () => <div>Redirecting...</div>,
});
